import {GET_FIO} from "../../../../enums/Profile/profile";

export const getFioInformatioAction = (data)=>{
    return{
        type:GET_FIO,
        payload:data,
    };
};
